<template>
<div >
    image url transfer to blob
    <div id="forAppend" class="demo"></div>
</div>
</template>

<script>
export default {
    name: "test",
    methods:{

        init:function(){
            var eleAppend = document.getElementById("forAppend");
            window.URL = window.URL || window.webkitURL;
            if (typeof history.pushState == "function") {
                var xhr = new XMLHttpRequest();
                var img_url = 'http://localhost:8080/img/toubulogo.e58bf9f5.png';
                // xhr.open("get", "此处填写您的图片地址", true);
                xhr.open("get", img_url, true);
                xhr.responseType = "blob";
                xhr.onload = function() {
                    if (this.status == 200) {
                        var blob = this.response;
                        var img = document.createElement("img");
                        img.onload = function(e) {
                            console.log(e)
                            window.URL.revokeObjectURL(img.src); // 清除释放
                        };
                        img.src = window.URL.createObjectURL(blob);
                        eleAppend.appendChild(img);
                    }
                }
                xhr.send();
            } else {
                eleAppend.innerHTML = '<p style="color:#cd0000;">请更换浏览器重试~</p>';
            }
        }
    },
    mounted:function(){

        this.init();
    }
}
</script>

<style scoped>

</style>